<template>
<slide-transition>
  <v-container>
    <v-flex column>
      <v-layout row justify-center style="margin-top:5px;" mb-3>
        <img :src="require('@/assets/images/logo.png')" height="160" style="margin-top:8px;"/>
      </v-layout>
      <v-layout row justify-center style="margin-top:5px;" mb-2>
        <span class="grey--text headline proxima-semi" xs2 >CONTRASEÑA CADUCADA</span>
      </v-layout>
    </v-flex>
    <v-layout justify-center mb-3>
      <span class="reddy--text title" xs2 >Por favor, introduzca una nueva contraseña para su cuenta</span>
    </v-layout>
    <v-layout justify-center>
      <v-flex xs4 x4 justify-center>
        <v-card style="padding:20px">
          <v-form v-model="valid" id="valid">
            <v-text-field
              v-model="password" id="password"
              :name="password"
              :rules="passwordRules"
              :type="showPassword1 ? 'text' : 'password'"
              label="Contraseña"
              required
              :append-icon="showPassword1 ? 'mdi-eye-off' : 'mdi-eye'"
              @click:append="showPassword1 = !showPassword1"
            ></v-text-field>
            <v-text-field
              v-model="passwordRepetida" id="passwordRepetida"
              :name="passwordRepetida"
              :rules="passwordRepetidaRules"
              :type="showPassword2 ? 'text' : 'password'"
              label="Repetir contraseña"
              required
              :append-icon="showPassword2 ? 'mdi-eye-off' : 'mdi-eye'"
              @click:append="showPassword2 = !showPassword2"
            ></v-text-field>
            <v-layout justify-center style="padding-top:30px">
              <v-btn :disabled="!valid || desactivarBoton" :loading="desactivarBoton" color="primary" @click="modificarExpiredPassword()">
                Modificar contraseña
              </v-btn>
            </v-layout>
          </v-form>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</slide-transition>
</template>

<script>
import { mapActions } from 'vuex'
export default {
  data () {
    return {
      password: '',
      passwordRepetida: '',
      userId: '',
      valid: false,
      passwordRules: [
        (v) => !!v || 'Campo obligatorio',
        (v) => v.length >= 8 || 'La contraseña debe tener un mín. de 8 carácteres.',
        (v) => {
          const pattern = /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])/;
          return (
            pattern.test(v) ||
              "La contraseña debe contener al menos una mayúscula, una minúscula y un número"
          )
        }
      ],
      passwordRepetidaRules: [
        (v) => !!v || 'Campo obligatorio',
        (v) => v === this.password || 'Las contraseñas no coinciden',
        (v) => v.length >= 8 || 'La contraseña debe tener un mín. de 8 carácteres.',
        (v) => {
          const pattern = /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])/;
          return (
            pattern.test(v) ||
              "La contraseña debe contener al menos una mayúscula, una minúscula y un número"
          )
        }
      ],
      desactivarBoton: false,
      showPassword1: false,
      showPassword2: false
    }
  },
  methods: {
    ...mapActions({
      modificarExpiredPasswordApi: 'login/modificarExpiredPassword',
      addAlert: 'alerts/add'
    }),
    modificarExpiredPassword () {
      this.desactivarBoton = true
      this.modificarExpiredPasswordApi({
        password: this.password,
        passwordActual: this.$route.params.passwordActual,
        userId: this.$route.params.userId,
        userMail: this.$route.params.userMail
      })
        .then(() => {
          this.addAlert({texto: this.$t('contraseñaModificada'), color: 'success'})
          this.$router.push({
            name: 'home'
          })
          this.desactivarBoton = false
        })
        .catch((error) => {
          this.desactivarBoton = false
          if (!error.code || error.code !== 1) {
            this.addAlert({texto: error.message, color: 'error'})
          }
        })
    }
  }
}
</script>
